import { Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import NccerLogo from 'assets/images/nccer/NCCER_logo_wordmark_positive_RGB.png';
import routes from 'store/configs/Routes';
import { getEmailLink } from 'util/Format';
import { getIconSvg } from 'util/Layout';

import styles from './AccessibilityStatementPage.module.scss';

const AccessibilityStatementPage: React.FunctionComponent = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.container}>
      <aside className={styles.sidebar}>
        <img src={NccerLogo} alt={'NCCER'} className={styles.nccerLogo} />
        <nav className={styles.menu}>
          <RouterLink to={routes.login} className={styles.link}>
            <div className={styles.navLinkContent}>
              <span aria-hidden={'true'}>{getIconSvg('home')}</span>
              <span className={styles.navLabel}>{'Login'}</span>
            </div>
          </RouterLink>
        </nav>
      </aside>
      <main className={styles.content}>
        <Typography color={'textPrimary'} className={styles.cardTitle} component={'h1'}>
          {'Accessibility Statement'}
        </Typography>
        <Typography paragraph={true} className={styles.cardDescription} component={'div'}>
          <p>
            {
              'We are working to make this entire website fully accessible to people with disabilities. However, we understand that some of our site content may not, as yet, achieve that goal.'
            }
          </p>
          <p>
            {
              'We offer to make anything that is found on our website available in an alternative format upon request. To request an alternative format, please contact our Customer Service department by email via '
            }
            {getEmailLink('support@nccer.org')}
            {'.'}
          </p>
        </Typography>
      </main>
    </div>
  );
};
export default AccessibilityStatementPage;
